
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Webhook } from "lucide-react";
import { WebhookConfig } from "./WebhookConfig";
import { TestMessage } from "./TestMessage";
import { WebhookEvents } from "./WebhookEvents";
import { ApiEndpoints } from "./ApiEndpoints";

export const HttpSmsInstructions = () => {
  return (
    <Card className="mt-8 bg-white/80 backdrop-blur-lg">
      <CardHeader className="bg-gradient-to-r from-hotbot-pink to-hotbot-purple text-white rounded-t-lg">
        <CardTitle className="text-center flex items-center justify-center gap-2">
          <Webhook className="w-5 h-5" />
          SMS Gateway API Documentation
        </CardTitle>
      </CardHeader>
      <CardContent className="p-6 space-y-4">
        <p className="text-gray-700">
          Our SMS Gateway allows you to send and receive SMS messages programmatically. Follow these steps to get started:
        </p>
        
        <ol className="list-decimal list-inside space-y-3 text-gray-700">
          <li>
            Configure your webhook endpoint to receive SMS events:
            <WebhookConfig />
          </li>
          <li>Use your API key from the API Keys section to authenticate requests</li>
          <li>
            Test your setup:
            <TestMessage />
          </li>
        </ol>

        <WebhookEvents />
        <ApiEndpoints />
      </CardContent>
    </Card>
  );
};
